import React from "react";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";
import "./Hero.css";

const Hero = ({ t }) => {
  const title = t?.title || ["Connecting Pakistan's Talent with", "Opportunities Worldwide"];
  const isLegacyTitle = title.length === 4;

  return (
    <section className="hero" id="home">
      <div className="hero-overlay" />
      <img className="hero-workers" src="/images/workers2.png" alt="Skilled workers ready for overseas manpower deployment" />
      <div className="hero-content">
        <div className="hero-copy">
          <p className="hero-kicker">{t?.kicker || "25+ YEARS OF TRUST & EXCELLENCE"}</p>
          <h1 className="hero-title">
            {isLegacyTitle ? (
              <>
                <span>{title[0]}</span>
                <span>{title[1]} <em>{title[2]}</em></span>
                <span><em>{title[3]}</em></span>
              </>
            ) : (
              title.map((line, index) => (
                <span key={line}>{index === title.length - 1 ? <em>{line}</em> : line}</span>
              ))
            )}
          </h1>
          <p className="hero-description">
            {t?.description || "We deliver reliable, efficient, and professional manpower recruitment solutions, connecting leading employers worldwide with Pakistan's skilled workforce."}
          </p>
          <div className="hero-actions">
            <a href="#contact" className="primary-button">{t?.primaryCta || "Hire Skilled Workers"} <FaArrowRight /></a>
            <a href="tel:+923335127407" className="secondary-button"><FaPhoneAlt /> {t?.secondaryCta || "Contact Us"}</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
